import { render } from "./CoverVersion.vue?vue&type=template&id=1b76d230&scoped=true"
import script from "./CoverVersion.vue?vue&type=script&lang=js"
export * from "./CoverVersion.vue?vue&type=script&lang=js"

import "./CoverVersion.vue?vue&type=style&index=0&id=1b76d230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b76d230"]])

export default __exports__